'use strict';

var ApiStatusCode = {
  OK: 200,
  ERROR: 500,
  UNAUTHORIZED: 401
};

module.exports = ApiStatusCode;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/api/status.js
 **/